import { IUserLogined, IUserResponse, Step1 } from '../types';
import { IAuthState } from './auth';
import { Logger } from 'sass';

const mutations = {
    SET_TYPE_IDENTITY(state: IAuthState, typeIdentity: string) {
        state.typeIdentity = typeIdentity;
    },
    SET_USER_REGISTERED(state: IAuthState, userRegistered: IUserResponse) {
        state.userRegistered = userRegistered;
    },
    SET_LOGIN_RESULT(state: IAuthState, loginSuccess: boolean) {
        state.loginSuccess = loginSuccess;
    },
    SET_USER_LOGINED(state: IAuthState, userLogined: IUserLogined) {
        state.userLogined = userLogined;
    },
    SET_STEP_1(state: IAuthState, step1: Step1) {
        state.step1 = step1;
    },
    SET_STEP_2(state: IAuthState, data: any) {
        state.step2 = data;
    },
    SET_STEP_3(state: IAuthState, data: any) {
        state.step3 = data;
    },
    SET_TYPE_DEFAULT(state: IAuthState, data: any) {
        state.typeDefault = data;
    },
    SET_NOTIFYSUCCESS(state: IAuthState, data: any) {
        state.setNotifySuccess = data;
    },
};

export default mutations;
